import React from 'react';

import { getStatisticsFromOrigin } from "../helpers/requestHandler";
import { renderFullScreen, exportData } from '../helpers/utils';

import { Card } from 'react-bootstrap';
import { Chart, CommonSeriesSettings, Series, Export, ArgumentAxis, Label, Legend, Tooltip, ValueAxis } from 'devextreme-react/chart';

class barChartCosting extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            seriesData: [],
            dataSource: '',
            getData: '',
        };
        window.lineChartHistoricUsers = this;
    }

    async componentDidMount() {
        await this.loadData();
    }

    loadData = async () => { //Adjust in regard to start date and end date
        let resp = await getStatisticsFromOrigin(global.config.backend.baseURI + "/api/Costing/GetCostByEntityAndCategory", global.config.dashboard.range, null, null, null)
        
        if(resp) {
            let object = resp.slice(-1)[0];
            let data = JSON.parse(object.data);
            let series = [];
            
            for(const key in data[0]) {
                if(key !== "CustomerInstance") {
                    series.push({ value: key, name: key })
                }
            }
    
            this.setState({dataSource: data, seriesData: series})    
        }  
    }

    render() {
        return (
        <Card className="rounded-4">
            <Card.Body>
            <Card.Title>
                Azure Monthly Costing
                <div className='float-end'>
                    <span className="fullscreen-link" onClick={() => {renderFullScreen("#chartCosting")}}>Full Screen</span>
                        <span> | </span>
                    <span className="fullscreen-link" onClick={() => {exportData("Costing", this.state.dataSource)}}>Export</span>
                </div>
            </Card.Title>
            <Card.Subtitle>
              Total billable Azure Cost for the previous month by cost category
            </Card.Subtitle>
            <Chart
                id="chartCosting"
                title="Costing Data"
                dataSource={this.state.dataSource}
                onLegendClick={this.legendClickHandler}
                resolveLabelOverlapping="stack"       
            >
            <CommonSeriesSettings argumentField="CustomerInstance" type="stackedBar" barWidth={100} barPadding={0} />
            {
              this.state.seriesData.map((item) => <Series
                key={item.value}
                valueField={item.value}
                name={item.name} />)
                
            }
            <ValueAxis maxValueMargin={0.01}>
                <Label customizeText={this.customizeText} />
            </ValueAxis>
            <ArgumentAxis>
                <Label
                    wordWrap="break"
                    overlappingBehavior={"rotate"}
                />
            </ArgumentAxis>
            <Legend
                verticalAlignment="top"
                horizontalAlignment="center"
                itemTextPosition="top"
            />
            <Export enabled={true} />
            <Tooltip
                enabled={true}
                location="edge"
                customizeTooltip={this.customizeTooltip}
                zIndex={10000}
            />
        </Chart>
            </Card.Body>
        </Card>        
        );
    }
    customizeTooltip(arg) {
        let cost = parseFloat(arg.valueText).toLocaleString('en-US', {
            style: 'currency',
            currency: 'GBP',
        });
        let totalCost = parseFloat(arg.total).toLocaleString('en-US', {
            style: 'currency',
            currency: 'GBP',
        });
        return {
            text: `${arg.seriesName} \n Cost: ${cost} \n \n Total Cost: ${totalCost} \n Percentage: ${arg.percentText}`,
        };
    }

    legendClickHandler(e) {
        // When using fullscreen we add an aditonal class called 'fullscreen', within the classList of the element the second value [1] will also be the class we want.
        // If we add more classes look to switch over to includes for the array.
        if(!e.element.classList.value.includes("fullscreen")) {
            const series = e.target;
            if (series.isVisible()) {
                series.hide();
            } else {
                series.show();
            }
        }
    }

    customizeText(arg) {
        return `£${arg.valueText}`;
    }
}

export default barChartCosting;
